import { apiJson } from './http'

export function listWorkflows() {
  return apiJson('/api/v1/workflows/')
}

export function getWorkflow(id) {
  return apiJson(`/api/v1/workflows/${id}`)
}

export function createWorkflow(payload) {
  return apiJson('/api/v1/workflows/', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function updateWorkflow(id, payload) {
  return apiJson(`/api/v1/workflows/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  })
}

export function deleteWorkflow(id) {
  return apiJson(`/api/v1/workflows/${id}`, {
    method: 'DELETE',
  })
}
